function urlQuery() {
    var str = window.location.href;
    var lastSlash = str.lastIndexOf('/');
    return str.substring(lastSlash+1);
}

export default urlQuery;